import React, {Component} from 'react';
import { Row, Col, Form, Input, Icon, Button, Progress } from 'antd';

const
FormItem = Form.Item,
CAPTCHA  = 'captcha',
NONE = 'none',
PENDING = 'pending',
SUCCESS = 'success',
FAILURE = 'failure'

export default Form.create()(
class GenericCaptcha extends Component {
    constructor(props) {
        super(props);

        this.loadCaptcha = this.props.services.loadCaptcha.bind(this);
        this.validateCaptcha = this.props.services.validateCaptcha.bind(this);
    }


    handleValidation(e){
      const {getFieldValue } =this.props.form;
      const validateCaptcha = this.validateCaptcha;
     setTimeout(function(){
        let captchaIput = getFieldValue("CaptchaForm-Captcha");
        validateCaptcha(captchaIput);
     } , 0)

    }

    componentDidMount() {
        this.loadCaptcha();

    }

    getCaptchaValidationView(status) {
        switch(status) {
            case PENDING:
                return (
                    <div style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                        <Icon type='loading'/>{' Validating code...'}
                    </div>
                );
            case SUCCESS:
                return (
                    <div>
                        <Progress type='circle' percent={100} width={40}/>
                        <div style={{
                                marginTop: '10px',
                                fontSize: '12px',
                                color: 'green',
                                fontStyle: 'italic',
                                fontWeight: 'bold'
                            }}>
                            {' Validation SUCCESSFUL. Ready to submit.'}
                        </div>
                    </div>
                );
            case FAILURE:
                return (
                    <div>
                        <Progress type='circle' percent={100} width={40} status='exception'/>
                        <div style={{
                                fontSize: '12px',
                                color: 'red',
                                fontStyle: 'italic',
                                fontWeight: 'bold'
                            }}>
                            {' Validation FAILURE...'}
                        </div>
                    </div>
                );
        }
    }

    getCaptchaView() {
        const { captcha } = this.props.captcha
        const  captchaBase64 = captcha.data;

        switch(captcha.status) {
            case NONE:
                return (
                    <div style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                        {'No code available...'}
                    </div>
                );
            case PENDING:
                return (
                    <div style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                        <Icon type='loading'/>{' Loading code...'}
                    </div>
                );
            case SUCCESS:
                return (
                    <div>
                        <img src={`data:image/png;base64,${captchaBase64}`}/>
                        <Button shape='circle' icon='sync' onClick={() =>   this.loadCaptcha()}></Button>
                        <div style={{ marginTop: '4px', fontSize: '12px', fontStyle: 'italic' }}>
                            {'Click reload button if a refresh is needed.'}
                        </div>
                    </div>
                );
            case FAILURE:
                return (
                    <div style={{ color: 'red', fontStyle: 'italic', fontWeight: 'bold' }}>
                        {'Unable to load the code...'}
                    </div>
                );
              }
      }

    getInput() {
        const
        { captchaOverrideView, requestValidation } = this.props

        let id = 'CaptchaForm-Captcha',
        props = {
            id: id,
            style: { width: '300px' }
        };

        return (<Input {...props} onChange={(e) => this.handleValidation(e)}/>);
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { state } = this.props;
        return (
            <div>
                <Form>
                    <Row type='flex' >
                        <Col span={24}>
                            <Row type='flex' >
                                <Col>
                                    <div style={{ display: 'table', textAlign: 'left', width: '300px', height: '38px' }}>
                                        <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                                            {this.getCaptchaView()}
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row type='flex' justify='center'>
                        <Col span={24} style={{ height: '40px' }}>
                            <FormItem >
                            {getFieldDecorator('CaptchaForm-Captcha', {})(
                                this.getInput())}
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
});
